<div class="row animated fadeIn">
  <div class="col-md-12">
    <div class="d-flex justify-content-between align-items-center mb-2">
      <h4 class="mb-0"><a href="javascript:void(0);" routerLink="/productmanagment/productlist"><span
            class="mdi mdi-arrow-left"></span></a> Add Master Product</h4>
    </div>

    <div class="card">
      <div class="card-body">
        <form [formGroup]="registerForm">
          <div class="form-row">
            <div class="form-group mb-1 col-lg-3 col-md-3 col-sm-12">
              <label class="col-form-label pt-0">Business Vertical <span class="required">*</span>
              </label>
              <angular2-multiselect [data]="businessStream" [(ngModel)]="selectedBusiness" [settings]="dropdownSetting"
                formControlName="BusinessVertical" (onSelect)="confirmYes($event,Confirm)"
                [ngClass]="{ 'is-invalid': submitted && f.BusinessVertical.errors }" fixSearchBug>
              </angular2-multiselect>
              <div *ngIf="submitted && f.BusinessVertical.errors" class="invalid-feedback">
                <div *ngIf="f.BusinessVertical.errors.required">Vertical is required</div>
              </div>
            </div>
          </div>

          <div class="table-responsive">
            <div formArrayName="rows">
              <table class="table table-bordered mt-3 mat-table" aria-hidden="true">
                <thead class="thead-light">

                  <tr>
                    <th *ngFor="let col of ProductHeader; index as i;" id="tab-selectbyid-{{i+1}}"
                      class="font-weight-bold">{{col}} <span
                        *ngIf="col!=='Brand' && col!=='Product Series' && col!=='Vat %' && col!='HVAC/ Project Series' && col!='MEP/ Project Series' && col!='Product/ Spare Series' && col!='Product/ Service Series' && col!='Product/ Installation Series'"
                        class="required">*</span></th>
                    <th class="text-center"><i class="mdi mdi-delete"></i></th>
                  </tr>

                </thead>

                <tbody *ngIf="isRender">
                  <tr *ngFor="let row of registerForm.controls.rows.controls; let i = index" [formArrayName]="i">

                    <td style="min-width:180px;">
                      <angular2-multiselect [data]="detailStream" [(ngModel)]="groups[i]" [settings]="dropdownSettings"
                        formControlName="BusinessCategory" (onSelect)="onDetailSelect($event)"
                        (onDeSelect)="onDetailSelect($event)" fixSearchBug>
                      </angular2-multiselect>
                      <div *ngIf="submitted && registerForm.controls.rows.controls[i].controls.BusinessCategory.errors">
                        <span style="color:red !important; font-size: 10px;">
                          Category is required</span>
                      </div>
                    </td>

                    <td style="min-width:195px;">
                      <mat-form-field class="example-full-width" appearance="fill">
                        <input type="text" placeholder="Product Group" class="form-control example-no-focus py-0"
                          aria-label="text" matInput [matAutocomplete]="auto" maxlength="50"
                          formControlName="ProductGroupName" (input)="NewSearchFun($event,i,1)">
                        <mat-autocomplete #auto="matAutocomplete">
                          <mat-option *ngFor="let option of productGroupHd | async" [value]="option">
                            {{option}}
                          </mat-option>
                        </mat-autocomplete>
                      </mat-form-field>
                      <div *ngIf="submitted && registerForm.controls.rows.controls[i].controls.ProductGroupName.errors">
                        <span style="color:red !important; font-size: 10px;">
                          Group is required</span>
                      </div>
                    </td>

                    <td style="min-width:180px;">
                      <mat-form-field class="example-full-width" appearance="fill">
                        <input type="text" class="form-control example-no-focus py-0" placeholder="Product Type"
                          aria-label="text" matInput [matAutocomplete]="auto1" maxlength="50"
                          formControlName="ProductTypeName" (input)="NewSearchFun($event,i,2)">
                        <mat-autocomplete #auto1="matAutocomplete">
                          <mat-option *ngFor="let option of ProductTypeNm | async" [value]="option">
                            {{option}}
                          </mat-option>
                        </mat-autocomplete>
                      </mat-form-field>
                      <div *ngIf="submitted && registerForm.controls.rows.controls[i].controls.ProductTypeName.errors">
                        <span style="color:red !important; font-size: 10px;">
                          Type is required</span>
                      </div>
                    </td>

                    <td style="min-width:180px;">
                      <mat-form-field class="example-full-width" appearance="fill">
                        <input type="text" placeholder="Brand" aria-label="text" maxlength="50"
                          formControlName="ProductBrandName" matInput [matAutocomplete]="auto2"
                          class="form-control example-no-focus py-0" (input)="NewSearchFun($event,i,3)">
                        <mat-autocomplete #auto2="matAutocomplete">
                          <mat-option *ngFor="let option of Brand | async" [value]="option">
                            {{option}}
                          </mat-option>
                        </mat-autocomplete>
                      </mat-form-field>
                    </td>

                    <td style="min-width:180px;">
                      <mat-form-field class="example-full-width" appearance="fill">
                        <input type="text" placeholder="Product Series" aria-label="text" matInput maxlength="100"
                          formControlName="ProductSeriesName" [matAutocomplete]="auto3"
                          class="form-control example-no-focus py-0" (input)="NewSearchFun($event,i,4)">
                        <mat-autocomplete #auto3="matAutocomplete">
                          <mat-option *ngFor="let option of Series | async" [value]="option">
                            {{option}}
                          </mat-option>
                        </mat-autocomplete>
                      </mat-form-field>
                    </td>

                    <td style="min-width:180px;">
                      <mat-form-field class="example-full-width" appearance="fill">
                        <input type="text" placeholder="Equipment Type" aria-label="text" matInput maxlength="50"
                          formControlName="Type" [matAutocomplete]="auto4" class="form-control example-no-focus py-0"
                          (input)="NewSearchFun($event,i,5)">
                        <mat-autocomplete #auto4="matAutocomplete">
                          <mat-option *ngFor="let option of Pro | async" [value]="option">
                            {{option}}
                          </mat-option>
                        </mat-autocomplete>
                      </mat-form-field>
                      <div *ngIf="submitted && registerForm.controls.rows.controls[i].controls.Type.errors">
                        <span style="color:red !important; font-size: 10px;">
                          Equipment Type is required</span>
                      </div>
                    </td>

                    <td style="min-width:180px;">
                      <input type="text" class="form-control" formControlName="ItemCode" maxlength="100"
                        placeholder="Item Code" (input)="NameSpaceNotAllowed($event)" fixSearchBug>
                      <div *ngIf="submitted && registerForm.controls.rows.controls[i].controls.ItemCode.errors">
                        <span style="color:red !important; font-size: 10px;">
                          Code is required</span>
                      </div>
                    </td>

                    <td style="min-width:180px;">
                      <input type="text" class="form-control" formControlName="Description" maxlength="100"
                        placeholder="Description" (input)="NameSpaceNotAllowed($event)" fixSearchBug>
                      <div *ngIf="submitted && registerForm.controls.rows.controls[i].controls.Description.errors">
                        <span style="color:red !important; font-size: 10px;">
                          Description is required</span>
                      </div>
                    </td>

                    <td style="min-width:95px;">
                      <select class="form-control" formControlName="IsVatAllow" [(ngModel)]="vat[i]"
                        (change)="onVatSelect($event, i)">
                        <option [value]="item['id']" *ngFor="let item of dropdownList6; index as i;">
                          {{item['itemName']}}</option>
                      </select>
                    </td>

                    <td style="min-width:100px;" *ngIf="disableValue[i]">
                      <input type="text" class="form-control" formControlName="VatRate" placeholder="VatRate"
                        (input)="NameSpaceNotAllowed($event); vatR($event, i)" maxlength="6" max="100"
                        appTwoDigitDecimaNumber (keyup)="getPrice(i)">
                      <div *ngIf="submitted && registerForm.controls.rows.controls[i].controls.VatRate.errors">
                        <span style="color:red !important; font-size: 10px;">
                          VatRate is required</span>
                      </div>
                    </td>

                    <td style="min-width:100px;" *ngIf="!disableValue[i]">
                      <input type="text" class="form-control" formControlName="VatRate" [value]="0" placeholder="0"
                        disabled>
                    </td>

                    <td>
                      <div class="d-flex">
                        <a href="javascript:void(0);"
                          class="btn bg-danger btn-sm btn btn-circle align-items-center d-flex justify-content-center text-white"
                          placement="bottom" (click)="onDeleteRow(i)" ngbTooltip="Delete"><span
                            class="mdi mdi-delete mdi-18px"></span>
                        </a>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="row justify-content-end align-items-center mt-3 mb-2 zIndexUp">
            <ul
              class="list-unstyled action-tool-bar col-xl-auto col-lg-auto col-md-10 col-sm-12 mb-0 d-flex align-items-center flex-wrap">
              <li class="mr-1"><a href="javascript:void(0);" class="btn btn-sm btn-light-info" (click)="Addrow()"><span
                    class="mdi mdi mdi-plus"></span>
                  Add More</a></li>
              <li> <button *ngIf="!multiClick" href="javascript:void(0);" type="submit"
                  class="btn btn-sm btn-light-info" (click)="onSubmit()"><span class="mdi mdi-content-save"></span>
                  Save</button>
                <button *ngIf="multiClick" href="javascript:void(0);" type="submit" class="btn btn-sm btn-light-info"
                  [disabled]="true"><span class="mdi mdi-content-save"></span>
                  Save</button>
              </li>
            </ul>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<ng-template #Confirm>
  <div class="modal-header">
    <h4 class="modal-title text-dark"><strong>Business Vertical</strong></h4>
    <button type="button" class="close" (click)="decline(); modalRef.hide();" data-dismiss="modal"
      aria-label="Close"><span aria-hidden="true">&times;</span></button>
  </div>
  <div class="modal-body text-center">
    <p class="text-left mb-2">Do you want to select "{{selectedbusiness}}"
      <br><br>
      Note - this vertical value can't be change once Selected
    </p>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-danger btn-sm" [disabled]="delNameDel"
      (click)="decline1(); onBusinessSelect(); modalRef.hide();">Yes</button>
    <button type="button" class="btn btn-sm btn btn-secondary ml-2"
      (click)="decline(); modalRef.hide();">Cancel</button>
  </div>
</ng-template>

<ngx-spinner type="ball-scale-multiple"></ngx-spinner>